const { honorificPrefixes, honorificSuffixes } = require('./titlesConfig.js');

function sophisticatedParse(name, honorifics) {
    let parts = [];
    const honorificParts = [];
    const nameParts = [];

    if(name){
        parts = name.split(' ');
        for(let part of parts){
            let isHonorific = honorifics.some(honorific => honorific.toLowerCase() === part.toLowerCase());

            if(isHonorific){
                honorificParts.push(part);
            }
            else {
                nameParts.push(part);
            }
        }
    }

    return {
        honorifics: honorificParts,
        name: nameParts
    };
}

function parseHonorifics(names, honorifics) {
    let result = {
        honorifics: [],
        names: []
    };
    const flatNames = names.join(' ').split(' ').filter(Boolean);
    for (let name of flatNames) {
        const { honorifics: honorificsProjected, name: nameProjected } = sophisticatedParse(name, honorifics);
        result.honorifics = result.honorifics.concat(honorificsProjected);
        result.names = result.names.concat(nameProjected);
    }
    return result;
}

export function processHonorifics(cards) {
    return cards.map(card => {
        if (!(card.n && card.n.value)) {
            return card;
        }

        const nameField = card.n.value;
        const parsedGivenName = parseHonorifics(nameField.givenName, honorificPrefixes);
        const parsedFamilyName = parseHonorifics(nameField.familyName, honorificSuffixes);

        return {
            ...card,
            n: {
                ...card.n,
                value: {
                    ...nameField,
                    familyName: parsedFamilyName.names,
                    givenName: parsedGivenName.names,
                    prefixes: parsedGivenName.honorifics,
                    suffixes: parsedFamilyName.honorifics,
                }
            }
        };
    });
}